import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52a206f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue'
import type { PPTTextElement } from '@/types/slides'
import ElementOutline from '@/views/components/element/ElementOutline.vue'

import useElementShadow from '@/views/components/element/hooks/useElementShadow'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTextElement',
  props: {
    elementInfo: {}
  },
  setup(__props: any) {

const props = __props

const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-text",
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${_ctx.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", {
        class: "element-content",
        style: _normalizeStyle({
          width: _ctx.elementInfo.vertical ? 'auto' : _ctx.elementInfo.width + 'px',
          height: _ctx.elementInfo.vertical ? _ctx.elementInfo.height + 'px' : 'auto',
          backgroundColor: _ctx.elementInfo.fill,
          opacity: _ctx.elementInfo.opacity,
          textShadow: _unref(shadowStyle),
          lineHeight: _ctx.elementInfo.lineHeight,
          letterSpacing: (_ctx.elementInfo.wordSpace || 0) + 'px',
          color: _ctx.elementInfo.defaultColor,
          fontFamily: _ctx.elementInfo.defaultFontName,
          writingMode: _ctx.elementInfo.vertical ? 'vertical-rl' : 'horizontal-tb',
        })
      }, [
        _createVNode(ElementOutline, {
          width: _ctx.elementInfo.width,
          height: _ctx.elementInfo.height,
          outline: _ctx.elementInfo.outline
        }, null, 8, ["width", "height", "outline"]),
        _createElementVNode("div", {
          class: "text ProseMirror-static",
          style: _normalizeStyle({
            '--paragraphSpace': `${_ctx.elementInfo.paragraphSpace === undefined ? 5 : _ctx.elementInfo.paragraphSpace}px`,
          }),
          innerHTML: _ctx.elementInfo.content
        }, null, 12, _hoisted_1)
      ], 4)
    ], 4)
  ], 4))
}
}

})